import { singleApiReducer } from './single-api-reducer';
import API from '../../API';

export const useUser = singleApiReducer(API.users.get);
